(function () {
  'use strict';

  var section = document.querySelector('[data-design-studio]');
  if (!section) return;

  var form = section.querySelector('[data-ds-form]');
  if (!form) return;

  var canvas = section.querySelector('[data-ds-canvas]');
  var mockupImg = section.querySelector('[data-ds-mockup-img]');
  var printArea = section.querySelector('[data-ds-print-area]');
  var artworkWrap = section.querySelector('[data-ds-artwork-wrap]');
  var artworkImg = section.querySelector('[data-ds-artwork-img]');
  var noPreviewEl = section.querySelector('[data-ds-no-preview]');

  var sideTabs = Array.prototype.slice.call(section.querySelectorAll('[data-ds-side-tab]'));

  var productButtons = Array.prototype.slice.call(section.querySelectorAll('[data-ds-product]'));
  var colorsContainer = section.querySelector('[data-ds-colors]');
  var sizesContainer = section.querySelector('[data-ds-sizes]');

  var SIDES = ['front', 'back'];
  var dropzones = {};
  var fileInputs = {};
  var fileRows = {};
  var fileNameEls = {};
  SIDES.forEach(function (side) {
    dropzones[side] = section.querySelector('[data-ds-dropzone="' + side + '"]');
    fileInputs[side] = section.querySelector('[data-ds-file-input="' + side + '"]');
    fileRows[side] = section.querySelector('[data-ds-file-row="' + side + '"]');
    fileNameEls[side] = section.querySelector('[data-ds-file-name="' + side + '"]');
  });

  var placementStep = section.querySelector('[data-ds-placement-step]');
  var scaleStep = section.querySelector('[data-ds-scale-step]');
  var placementSideLabel = section.querySelector('[data-ds-placement-side-label]');
  var placementButtons = Array.prototype.slice.call(section.querySelectorAll('[data-ds-placement]'));
  var scaleInput = section.querySelector('[data-ds-scale]');
  var scaleValueEl = section.querySelector('[data-ds-scale-value]');
  var scaleInchesInput = section.querySelector('[data-ds-scale-inches]');
  var sizeReadoutEl = section.querySelector('[data-ds-size-readout]');
  var sizeReadoutValueEl = section.querySelector('[data-ds-print-size-value]');

  var priceEl = section.querySelector('[data-ds-price]');
  var unavailableEl = section.querySelector('[data-ds-unavailable]');
  var variantIdInput = section.querySelector('[data-ds-variant-id]');
  var propPlacement = {};
  var propScale = {};
  var propPosition = {};
  var previewFileInputs = {};
  SIDES.forEach(function (side) {
    propPlacement[side] = section.querySelector('[data-ds-prop-placement="' + side + '"]');
    propScale[side] = section.querySelector('[data-ds-prop-scale="' + side + '"]');
    propPosition[side] = section.querySelector('[data-ds-prop-position="' + side + '"]');
    previewFileInputs[side] = section.querySelector('[data-ds-preview-file="' + side + '"]');
  });
  var submitBtn = section.querySelector('[data-ds-submit]');
  var qtyInput = section.querySelector('[data-ds-qty-input]');
  var qtyDecrease = section.querySelector('[data-ds-qty-decrease]');
  var qtyIncrease = section.querySelector('[data-ds-qty-increase]');
  var saveButtons = Array.prototype.slice.call(section.querySelectorAll('[data-ds-save]'));

  var productData = [];
  section.querySelectorAll('[data-ds-product-json]').forEach(function (el) {
    productData[parseInt(el.getAttribute('data-index'), 10)] = JSON.parse(el.textContent);
  });

  function freshSideState() {
    return {
      placement: null,
      scale: 100,
      posXPct: null,
      posYPct: null,
      hasArtwork: false,
      isImagePreviewable: false,
      artworkUrl: null,
      trimFracW: 1,
      contentAspect: null,
    };
  }

  var state = {
    productIndex: 0,
    color: null,
    size: null,
    activeSide: 'front',
    sides: {
      front: freshSideState(),
      back: freshSideState(),
    },
  };

  function cur() {
    return state.sides[state.activeSide];
  }

  function money(cents) {
    if (window.themeMoneyFormat) {
      return window.themeMoneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function currentProduct() {
    return productData[state.productIndex];
  }

  function optionPosition(product, name) {
    var opt = (product.options || []).filter(function (o) {
      return o.name === name;
    })[0];
    return opt ? opt.position : null;
  }

  var QTY_TIERS = [
    { max: 5, value: '1-5' },
    { max: 11, value: '6-11' },
    { max: 47, value: '12-47' },
    { max: 95, value: '48-95' },
    { max: Infinity, value: '96+' },
  ];

  function tierForQty(qty) {
    for (var i = 0; i < QTY_TIERS.length; i++) {
      if (qty <= QTY_TIERS[i].max) return QTY_TIERS[i].value;
    }
    return QTY_TIERS[QTY_TIERS.length - 1].value;
  }

  function findVariant() {
    var product = currentProduct();
    if (!product || !product.variants) return null;
    var colorPos = optionPosition(product, 'Color');
    var sizePos = optionPosition(product, 'Size');
    var tierPos = optionPosition(product, 'Quantity Tier');
    var tierValue = tierPos ? tierForQty(parseInt(qtyInput.value, 10) || 1) : null;
    return (
      product.variants.filter(function (v) {
        var colorMatch = !colorPos || v['option' + colorPos] === state.color;
        var sizeMatch = !sizePos || v['option' + sizePos] === state.size;
        var tierMatch = !tierPos || v['option' + tierPos] === tierValue;
        return colorMatch && sizeMatch && tierMatch;
      })[0] || null
    );
  }

  function withWidthParam(src, width) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/([?&])width=\d+/, '$1width=' + width);
    }
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function updateMockupImage() {
    var product = currentProduct();
    if (!product) return;

    if (state.activeSide === 'back') {
      var backForColor = product.backImages && state.color && product.backImages[state.color];
      var backSrc = backForColor || product.mockupBack;
      if (backSrc) mockupImg.src = backSrc.indexOf('width=') > -1 ? backSrc : withWidthParam(backSrc, 900);
      return;
    }

    var variant = findVariant();
    var variantImage = variant && variant.featured_image && variant.featured_image.src;
    var frontSrc = variantImage ? withWidthParam(variantImage, 900) : product.mockupFront;
    if (frontSrc) mockupImg.src = frontSrc;
  }

  function mockupSrcForSide(side) {
    var product = currentProduct();
    if (!product) return null;
    if (side === 'back') {
      var backForColor = product.backImages && state.color && product.backImages[state.color];
      return backForColor || product.mockupBack;
    }
    var variant = findVariant();
    var variantImage = variant && variant.featured_image && variant.featured_image.src;
    return variantImage || product.mockupFront;
  }

  function loadImageEl(src, crossOrigin) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (crossOrigin) img.crossOrigin = 'anonymous';
      img.onload = function () {
        resolve(img);
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  function flashSaveButton(btn, text) {
    if (!btn) return;
    if (!btn.hasAttribute('data-original-text')) {
      btn.setAttribute('data-original-text', btn.textContent);
    }
    btn.textContent = text;
    btn.classList.add('is-active');
    clearTimeout(btn._flashTimer);
    btn._flashTimer = setTimeout(function () {
      btn.textContent = btn.getAttribute('data-original-text');
      btn.classList.remove('is-active');
    }, 2200);
  }

  function saveMockup(side, btn) {
    var mockupSrc = mockupSrcForSide(side);
    if (!mockupSrc) {
      flashSaveButton(btn, 'Choose a blank first');
      return;
    }
    var s = state.sides[side];
    var size = 1000;

    loadImageEl(withWidthParam(mockupSrc, size), true)
      .then(function (mockupImgEl) {
        var offCanvas = document.createElement('canvas');
        offCanvas.width = size;
        offCanvas.height = size;
        var ctx = offCanvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, size, size);

        var fitScale = Math.min(size / mockupImgEl.naturalWidth, size / mockupImgEl.naturalHeight);
        var drawW = mockupImgEl.naturalWidth * fitScale;
        var drawH = mockupImgEl.naturalHeight * fitScale;
        ctx.drawImage(mockupImgEl, (size - drawW) / 2, (size - drawH) / 2, drawW, drawH);

        var needsArtwork = s.hasArtwork && s.isImagePreviewable && s.artworkUrl && s.placement;
        var artworkPromise = needsArtwork ? loadImageEl(s.artworkUrl, false) : Promise.resolve(null);

        return artworkPromise.then(function (artworkImgEl) {
          if (artworkImgEl) {
            var widthPct = ((s.placement.w / 200) * 100 * s.scale) / 100;
            var artW = (widthPct / 100) * size;
            var artH = artW * (artworkImgEl.naturalHeight / artworkImgEl.naturalWidth);
            var centerX = (s.posXPct / 100) * size;
            var centerY = (s.posYPct / 100) * size;
            ctx.drawImage(artworkImgEl, centerX - artW / 2, centerY - artH / 2, artW, artH);
          }
          return offCanvas;
        });
      })
      .then(function (offCanvas) {
        offCanvas.toBlob(function (blob) {
          if (!blob) {
            flashSaveButton(btn, 'Save failed');
            return;
          }
          var url = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.download = side + '-mockup.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(function () {
            URL.revokeObjectURL(url);
          }, 1000);
          flashSaveButton(btn, 'Saved!');
        }, 'image/png');
      })
      .catch(function (err) {
        /* Image failed to load (e.g. CORS-blocked mockup source), or the
           canvas was tainted by a cross-origin image and toBlob() threw. */
        if (window.console && console.error) console.error('Design Studio: save mockup failed', err);
        flashSaveButton(btn, 'Save failed');
      });
  }

  saveButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      saveMockup(btn.getAttribute('data-ds-save'), btn);
    });
  });

  /* Composite a shirt+design preview PNG for a side, for attaching to the
     cart line item as a hidden file property (so the cart/order can show
     the design on the shirt, not just a blank mockup). Resolves to null
     when there's no artwork placed on that side, or if compositing fails
     (e.g. a CORS-blocked mockup source) -- add-to-cart still proceeds. */
  function buildCartPreviewBlob(side) {
    var s = state.sides[side];
    var mockupSrc = mockupSrcForSide(side);
    if (!mockupSrc || !s.hasArtwork || !s.isImagePreviewable || !s.artworkUrl || !s.placement || s.posXPct == null) {
      return Promise.resolve(null);
    }
    var size = 1000;

    return loadImageEl(withWidthParam(mockupSrc, size), true)
      .then(function (mockupImgEl) {
        var offCanvas = document.createElement('canvas');
        offCanvas.width = size;
        offCanvas.height = size;
        var ctx = offCanvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, size, size);

        var fitScale = Math.min(size / mockupImgEl.naturalWidth, size / mockupImgEl.naturalHeight);
        var drawW = mockupImgEl.naturalWidth * fitScale;
        var drawH = mockupImgEl.naturalHeight * fitScale;
        ctx.drawImage(mockupImgEl, (size - drawW) / 2, (size - drawH) / 2, drawW, drawH);

        return loadImageEl(s.artworkUrl, false).then(function (artworkImgEl) {
          var widthPct = ((s.placement.w / 200) * 100 * s.scale) / 100;
          var artW = (widthPct / 100) * size;
          var artH = artW * (artworkImgEl.naturalHeight / artworkImgEl.naturalWidth);
          var centerX = (s.posXPct / 100) * size;
          var centerY = (s.posYPct / 100) * size;
          ctx.drawImage(artworkImgEl, centerX - artW / 2, centerY - artH / 2, artW, artH);
          return offCanvas;
        });
      })
      .then(function (offCanvas) {
        return new Promise(function (resolve) {
          offCanvas.toBlob(function (blob) {
            resolve(blob);
          }, 'image/png');
        });
      })
      .catch(function () {
        return null;
      });
  }

  function updatePrintArea() {
    var s = cur();
    if (!s.placement) {
      printArea.hidden = true;
      return;
    }
    printArea.hidden = false;
    printArea.style.left = (s.placement.x / 200) * 100 + '%';
    printArea.style.top = (s.placement.y / 200) * 100 + '%';
    printArea.style.width = (s.placement.w / 200) * 100 + '%';
    printArea.style.height = (s.placement.h / 200) * 100 + '%';
  }

  function centerArtworkInPrintArea(s) {
    if (!s.placement) return;
    s.posXPct = ((s.placement.x + s.placement.w / 2) / 200) * 100;
    s.posYPct = ((s.placement.y + s.placement.h / 2) / 200) * 100;
  }

  /* The Full Front placement preset (rect_w: 88 out of the 0-200 canvas
     scale) is calibrated to a real 16in-wide DTG print area, so that ratio
     converts any placement width/scale combo into real inches. */
  var INCHES_PER_UNIT = 16 / 88;
  var MAX_WIDTH_IN = 16;

  /* Uploaded artwork files often have transparent padding around the
     actual printed graphic (e.g. a logo exported on a larger canvas),
     so the visible ink is smaller than the full image's pixel bounds.
     Scanning the image's alpha channel for the true content bounding box
     lets every size calculation below be based on what will actually get
     printed, not the raw file dimensions -- otherwise "16in wide" always
     leaves a gap around the edges equal to the file's built-in padding. */
  function detectContentBounds(img) {
    var w = img.naturalWidth;
    var h = img.naturalHeight;
    if (!w || !h) return null;
    try {
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      var data = ctx.getImageData(0, 0, w, h).data;
      var step = Math.max(1, Math.floor(Math.max(w, h) / 800));
      var minX = w;
      var minY = h;
      var maxX = -1;
      var maxY = -1;
      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          if (data[(y * w + x) * 4 + 3] > 10) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return null;
      return { width: maxX - minX + step, height: maxY - minY + step };
    } catch (e) {
      /* Non-image content or a canvas security error -- fall back to the
         full image bounds elsewhere. */
      return null;
    }
  }

  /* Caps how far the Design size slider can go for the selected placement
     so the printed design can never exceed 16in wide, no matter which
     preset (each with its own base width) is active. trimFracW scales
     this up when the artwork file has transparent padding, so the VISIBLE
     ink -- not the padded file -- is what tops out at 16in. */
  function maxScaleForPlacement(placement, trimFracW) {
    if (!placement) return 160;
    var fw = trimFracW || 1;
    var baseWidthIn = placement.w * INCHES_PER_UNIT * fw;
    if (baseWidthIn <= 0) return 160;
    return Math.max(40, Math.min(160, Math.round((MAX_WIDTH_IN / baseWidthIn) * 100)));
  }

  function widthInForScale(placement, scale, trimFracW) {
    return placement.w * (scale / 100) * INCHES_PER_UNIT * (trimFracW || 1);
  }

  function scaleForWidthIn(placement, widthIn, trimFracW) {
    return (widthIn / (placement.w * INCHES_PER_UNIT * (trimFracW || 1))) * 100;
  }

  function updateScaleInchesInput() {
    if (!scaleInchesInput) return;
    var s = cur();
    if (!s.placement) return;
    var max = maxScaleForPlacement(s.placement, s.trimFracW);
    scaleInchesInput.min = widthInForScale(s.placement, 40, s.trimFracW).toFixed(1);
    scaleInchesInput.max = widthInForScale(s.placement, max, s.trimFracW).toFixed(1);
    scaleInchesInput.value = widthInForScale(s.placement, s.scale, s.trimFracW).toFixed(1);
  }

  function updateScaleBounds() {
    var s = cur();
    var max = maxScaleForPlacement(s.placement, s.trimFracW);
    scaleInput.max = max;
    if (s.scale > max) s.scale = max;
    scaleInput.value = s.scale;
    scaleValueEl.textContent = s.scale + '%';
    updateScaleInchesInput();
  }

  function updateSizeReadout() {
    if (!sizeReadoutEl) return;
    var s = cur();
    if (!s.hasArtwork || !s.isImagePreviewable || !s.placement || !artworkImg.naturalWidth) {
      sizeReadoutEl.hidden = true;
      return;
    }
    var widthIn = widthInForScale(s.placement, s.scale, s.trimFracW);
    var aspect = s.contentAspect || artworkImg.naturalHeight / artworkImg.naturalWidth;
    var heightIn = widthIn * aspect;
    sizeReadoutValueEl.textContent = widthIn.toFixed(1) + '" x ' + heightIn.toFixed(1) + '"';
    sizeReadoutEl.hidden = false;
  }

  function applyArtworkTransform() {
    var s = cur();
    if (!s.hasArtwork || !s.isImagePreviewable || !s.placement) {
      updateSizeReadout();
      return;
    }
    var widthPct = ((s.placement.w / 200) * 100 * s.scale) / 100;
    artworkWrap.style.width = widthPct + '%';
    artworkWrap.style.left = s.posXPct + '%';
    artworkWrap.style.top = s.posYPct + '%';
    updateSizeReadout();
  }

  function renderArtworkForActiveSide() {
    var s = cur();
    if (s.hasArtwork && s.isImagePreviewable && s.artworkUrl) {
      artworkImg.src = s.artworkUrl;
      artworkImg.hidden = false;
      artworkWrap.hidden = false;
      noPreviewEl.hidden = true;
    } else if (s.hasArtwork && !s.isImagePreviewable) {
      artworkWrap.hidden = true;
      noPreviewEl.hidden = false;
    } else {
      artworkWrap.hidden = true;
      noPreviewEl.hidden = true;
    }
    applyArtworkTransform();
  }

  function renderPlacementButtonsForActiveSide() {
    var s = cur();
    placementButtons.forEach(function (btn) {
      var isBackBtn = btn.getAttribute('data-back') === 'true';
      var matches = (state.activeSide === 'back') === isBackBtn;
      btn.hidden = !matches;
      var isSelected = !!s.placement && s.placement.label === btn.getAttribute('data-label') && matches;
      btn.classList.toggle('is-selected', isSelected);
    });
    if (placementSideLabel) {
      placementSideLabel.textContent = state.activeSide === 'back' ? 'Back' : 'Front';
    }
  }

  function anyArtworkUploaded() {
    return state.sides.front.hasArtwork || state.sides.back.hasArtwork;
  }

  function renderActiveSide() {
    updateMockupImage();
    renderPlacementButtonsForActiveSide();
    updateScaleBounds();
    updatePrintArea();
    renderArtworkForActiveSide();
    placementStep.hidden = !anyArtworkUploaded();
    scaleStep.hidden = !anyArtworkUploaded();
  }

  function updatePriceAndAvailability() {
    var variant = findVariant();
    if (!variant) {
      priceEl.textContent = '—';
      unavailableEl.hidden = true;
      submitBtn.disabled = true;
      variantIdInput.value = '';
      return;
    }
    priceEl.textContent = money(variant.price) + ' each';
    var unavailable = !variant.available;
    unavailableEl.hidden = !unavailable;
    variantIdInput.value = variant.id;

    var frontReady = state.sides.front.hasArtwork && state.sides.front.placement;
    var backReady = state.sides.back.hasArtwork && state.sides.back.placement;
    submitBtn.disabled = unavailable || !(frontReady || backReady);
  }

  function selectProduct(index) {
    state.productIndex = index;
    productButtons.forEach(function (btn, i) {
      btn.classList.toggle('is-selected', i === index);
    });
    section.querySelectorAll('[data-ds-swatches-for]').forEach(function (el) {
      el.hidden = parseInt(el.getAttribute('data-ds-swatches-for'), 10) !== index;
    });
    section.querySelectorAll('[data-ds-sizes-for]').forEach(function (el) {
      el.hidden = parseInt(el.getAttribute('data-ds-sizes-for'), 10) !== index;
    });

    var activeColorBtn = section.querySelector('[data-ds-swatches-for="' + index + '"] [data-ds-color-value]');
    var activeSizeBtn = section.querySelector('[data-ds-sizes-for="' + index + '"] [data-ds-size-value]');
    state.color = activeColorBtn ? activeColorBtn.getAttribute('data-ds-color-value') : null;
    state.size = activeSizeBtn ? activeSizeBtn.getAttribute('data-ds-size-value') : null;

    section.querySelectorAll('[data-ds-swatches-for="' + index + '"] .swatch').forEach(function (btn, i) {
      btn.classList.toggle('is-selected', i === 0);
    });
    section.querySelectorAll('[data-ds-sizes-for="' + index + '"] .option-pill').forEach(function (btn, i) {
      btn.classList.toggle('is-selected', i === 0);
    });

    renderActiveSide();
    updatePriceAndAvailability();
  }

  productButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectProduct(parseInt(btn.getAttribute('data-index'), 10));
    });
  });

  if (colorsContainer) {
    colorsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ds-color-value]');
      if (!btn) return;
      var group = btn.closest('[data-ds-swatches-for]');
      group.querySelectorAll('.swatch').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      state.color = btn.getAttribute('data-ds-color-value');
      updateMockupImage();
      updatePriceAndAvailability();
    });
  }

  if (sizesContainer) {
    sizesContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ds-size-value]');
      if (!btn) return;
      var group = btn.closest('[data-ds-sizes-for]');
      group.querySelectorAll('.option-pill').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      state.size = btn.getAttribute('data-ds-size-value');
      updatePriceAndAvailability();
    });
  }

  /* Side tabs (Front / Back) */
  sideTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var side = tab.getAttribute('data-ds-side-tab');
      if (side === state.activeSide) return;
      state.activeSide = side;
      sideTabs.forEach(function (t) {
        t.classList.toggle('is-selected', t === tab);
      });
      renderActiveSide();
    });
  });

  /* Placement presets, filtered per side */
  function firstPlacementForSide(side) {
    return (
      placementButtons.filter(function (btn) {
        return (btn.getAttribute('data-back') === 'true') === (side === 'back');
      })[0] || null
    );
  }

  function selectPlacement(btn) {
    var s = cur();
    s.placement = {
      label: btn.getAttribute('data-label'),
      x: parseFloat(btn.getAttribute('data-rect-x')),
      y: parseFloat(btn.getAttribute('data-rect-y')),
      w: parseFloat(btn.getAttribute('data-rect-w')),
      h: parseFloat(btn.getAttribute('data-rect-h')),
      back: btn.getAttribute('data-back') === 'true',
    };
    centerArtworkInPrintArea(s);
    updateScaleBounds();
    renderPlacementButtonsForActiveSide();
    updatePrintArea();
    applyArtworkTransform();
    updatePriceAndAvailability();
  }

  placementButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectPlacement(btn);
    });
  });

  scaleInput.addEventListener('input', function () {
    var s = cur();
    s.scale = parseInt(scaleInput.value, 10);
    scaleValueEl.textContent = s.scale + '%';
    updateScaleInchesInput();
    applyArtworkTransform();
  });

  if (scaleInchesInput) {
    scaleInchesInput.addEventListener('input', function () {
      var s = cur();
      if (!s.placement) return;
      var widthIn = parseFloat(scaleInchesInput.value);
      if (isNaN(widthIn) || widthIn <= 0) return;
      var max = maxScaleForPlacement(s.placement, s.trimFracW);
      s.scale = Math.round(Math.max(40, Math.min(max, scaleForWidthIn(s.placement, widthIn, s.trimFracW))));
      scaleInput.value = s.scale;
      scaleValueEl.textContent = s.scale + '%';
      applyArtworkTransform();
    });
    scaleInchesInput.addEventListener('change', function () {
      updateScaleInchesInput();
    });
  }

  /* Artwork upload + live preview, per side */
  function handleFile(file, side) {
    if (!file) return;
    var s = state.sides[side];
    fileNameEls[side].textContent = file.name;
    dropzones[side].querySelector('[data-ds-dropzone-prompt]').hidden = true;
    fileRows[side].hidden = false;
    s.hasArtwork = true;

    var isImage = /^image\/(png|jpeg|jpg|svg\+xml)$/.test(file.type);
    s.isImagePreviewable = isImage;
    s.artworkUrl = isImage ? URL.createObjectURL(file) : null;

    if (!s.placement) {
      var defaultBtn = firstPlacementForSide(side);
      if (defaultBtn) {
        var prevActive = state.activeSide;
        state.activeSide = side;
        selectPlacement(defaultBtn);
        state.activeSide = prevActive;
      }
    }

    if (side === state.activeSide) {
      renderActiveSide();
    } else {
      placementStep.hidden = !anyArtworkUploaded();
      scaleStep.hidden = !anyArtworkUploaded();
    }
    updatePriceAndAvailability();
  }

  SIDES.forEach(function (side) {
    var input = fileInputs[side];
    var zone = dropzones[side];
    if (!input || !zone) return;

    input.addEventListener('change', function () {
      if (input.files[0]) handleFile(input.files[0], side);
    });

    ['dragenter', 'dragover'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.remove('is-dragover');
      });
    });
    zone.addEventListener('drop', function (e) {
      var file = e.dataTransfer.files[0];
      if (file) {
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
        } catch (err) {
          /* Safari fallback: DataTransfer construction may be unsupported; the
             visual preview still works, only the actual form submission would
             need the user to re-pick the file via the input. */
        }
        handleFile(file, side);
      }
    });
  });

  /* Drag to reposition */
  var dragging = false;
  function pointerToPct(e) {
    var rect = canvas.getBoundingClientRect();
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100)),
      y: Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100)),
    };
  }

  function startDrag(e) {
    var s = cur();
    if (!s.hasArtwork || !s.isImagePreviewable) return;
    dragging = true;
    artworkWrap.classList.add('is-dragging');
    e.preventDefault();
  }

  function moveDrag(e) {
    if (!dragging) return;
    var pct = pointerToPct(e);
    var s = cur();
    s.posXPct = pct.x;
    s.posYPct = pct.y;
    applyArtworkTransform();
  }

  function endDrag() {
    dragging = false;
    artworkWrap.classList.remove('is-dragging');
  }

  artworkImg.addEventListener('load', function () {
    var s = cur();
    var oldMax = s.placement ? maxScaleForPlacement(s.placement, s.trimFracW) : null;
    var wasMaxed = oldMax !== null && s.scale >= oldMax;

    var trimmed = detectContentBounds(artworkImg);
    if (trimmed) {
      s.trimFracW = trimmed.width / artworkImg.naturalWidth;
      s.contentAspect = trimmed.height / trimmed.width;
    } else {
      s.trimFracW = 1;
      s.contentAspect = artworkImg.naturalHeight / artworkImg.naturalWidth;
    }

    if (s.placement) {
      if (wasMaxed) s.scale = maxScaleForPlacement(s.placement, s.trimFracW);
      updateScaleBounds();
      applyArtworkTransform();
    } else {
      updateSizeReadout();
    }
  });
  artworkWrap.addEventListener('pointerdown', startDrag);
  window.addEventListener('pointermove', moveDrag);
  window.addEventListener('pointerup', endDrag);
  artworkWrap.addEventListener('touchstart', startDrag, { passive: false });
  window.addEventListener('touchmove', moveDrag, { passive: false });
  window.addEventListener('touchend', endDrag);

  /* Quantity stepper */
  if (qtyDecrease && qtyIncrease && qtyInput) {
    qtyDecrease.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      updatePriceAndAvailability();
    });
    qtyIncrease.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      updatePriceAndAvailability();
    });
    qtyInput.addEventListener('input', updatePriceAndAvailability);
  }

  /* Submit: fill in the descriptive hidden properties, attach a composited
     shirt+design preview image per side (for the cart/order to display),
     then post -- form.submit() bypasses this listener, so there's no
     re-entrancy to guard against. */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    SIDES.forEach(function (side) {
      var s = state.sides[side];
      if (!s.hasArtwork || !s.placement) {
        propPlacement[side].value = '';
        propScale[side].value = '';
        propPosition[side].value = '';
        return;
      }
      propPlacement[side].value = s.placement.label;
      propScale[side].value = widthInForScale(s.placement, s.scale, s.trimFracW).toFixed(1) + '" wide';
      if (s.isImagePreviewable && s.posXPct != null) {
        propPosition[side].value = Math.round(s.posXPct) + '% from left, ' + Math.round(s.posYPct) + '% from top';
      } else {
        propPosition[side].value = 'See placement selection';
      }
    });

    Promise.all(
      SIDES.map(function (side) {
        return buildCartPreviewBlob(side).then(function (blob) {
          if (!blob || !previewFileInputs[side]) return;
          try {
            var file = new File([blob], side + '-design-preview.png', { type: 'image/png' });
            var dt = new DataTransfer();
            dt.items.add(file);
            previewFileInputs[side].files = dt.files;
          } catch (err) {
            /* DataTransfer/File unsupported -- submit without the preview image. */
          }
        });
      })
    ).then(function () {
      form.submit();
    });
  });

  /* Init */
  selectProduct(0);
})();
